import React from 'react'
import { Grid } from '@material-ui/core'
import { SelectAnimalFetchInput, SelectInput } from 'src/components'

import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { FormattedOption } from 'src/dto/animal.dto'
import { MovimentationForm } from 'src/@types/validations/Animal'
import { LotDto } from 'src/dto/lot.dto'
import { PastureDto } from 'src/dto/pasture.dto'

interface AnimalMovimentationProps {
  lotList: LotDto[]
  pastureList: PastureDto[]
}
export const AnimalMovimentation: React.FC<AnimalMovimentationProps> = ({ lotList, pastureList }) => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<MovimentationForm>()

  const styles = useStyles()

  return (
    <div className={styles.inputWithEditToggle}>
      <SelectAnimalFetchInput
        label='Animal'
        selectBy='id'
        showBy={['cdn', 'nome']}
        hidden={['MT', 'VD']}
        value={watch('idAnimal') || ''}
        name='idAnimal'
        error={errors?.idAnimal?.message}
        placeholder='Selecionar animal'
        onChange={(item: FormattedOption) => {
          setValue('idAnimal', item.id)
          clearErrors('idAnimal')
        }}
      />
      <Grid container spacing={3} style={{ marginTop: 8 }}>
        <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
          <SelectInput
            label='Lote destino'
            selectBy='idLote'
            showBy={['descricao']}
            options={lotList}
            value={watch('loteDestino') || ''}
            // disabled={!!saleData?.idVenda}

            error={errors?.loteDestino?.message}
            placeholder='Selecionar lote de destino'
            onChange={(item: any) => {
              setValue('loteDestino', item.id)
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
          <SelectInput
            label='Pasto destino'
            selectBy='idPasto'
            showBy={['descricao']}
            options={pastureList}
            value={watch('pastoDestino') || ''}
            // disabled={!!saleData?.idVenda}

            error={errors?.pastoDestino?.message}
            placeholder='Selecionar pasto de destino'
            onChange={(item: any) => {
              setValue('pastoDestino', item.id)
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}
